import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IReserveBreakdown } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getPoolShareFactorConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_reserves_breakdown', timeframe)) as IReserveBreakdown[]
	const series1 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.BOND_REWARDS }
	})
	const series2 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.OTHER_REWARDS }
	})
	const series3 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.BOND_SHARE_FACTOR_PCT }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'earnings to nodes',
			type: 'bars',
			seriesGroup: '[rune]',
			color: 'green',
			unitSymbol: 'ᚱ'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'other',
			type: 'bars',
			seriesGroup: '[rune]',
			color: 'orange',
			unitSymbol: 'ᚱ'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'BondShareFactor',
			type: 'line',
			seriesGroup: ' [%]',
			color: `${color}`,
			unitSymbol: '%'
		}
	]

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const PoolShareFactor = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getPoolShareFactorConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Bond Share Factor"
			chartDesc="The percentage of total protocol earnings that is directed to node operators."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="9bda51b5-c3ad-4ab6-abd8-17a004ace38d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default PoolShareFactor
